import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
} from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  CssBaseline,
  ThemeProvider,
  createTheme,
  Box,
  useMediaQuery,
} from "@mui/material";
//---------------- Styles---------------- 
// import './stylesheet.css'; // Removed - using Tailwind CDN in index.html
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.css';
import './loding.css';

//---------------- Auth---------------- 
import { AuthProvider, useAuth } from "./AuthContext";

//---------------- Navbar + Logout---------------- 
import HorizontalNavbar from "./HorizontalNavbar";
import MobileBottomNav from "./MobileBottomNav";
import Logout from "./Logout";

//---------------- PWA Components---------------- 
// PWA Status component removed

//---------------- Service Worker Registration---------------- 
// Service worker registration removed

//---------------- Styles---------------- 
// import './stylesheet.css'; // Removed - using Tailwind CDN in index.html
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.css';
import './loding.css';
import LodingComponent from "./loding";
// import Loginlogo from "./Loginlogo.png";

//-----------SessionTimeOut---------
import SessionTimeout from "./SessionTimeout";

//-----------Company----------------
import CompanyEdit from "./components/pages/Company/Edit";

//-----------Home-------------------
import Home from "./components/pages/Home";
//-----------Role-------------------
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";

//-----------User-------------------
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//-----------Client-------------------
import ClientIndex from "./components/pages/Client/Index";

//-----------Vendor-------------------
import VendorIndex from "./components/pages/Vendor/Index";

//-----------AccountHead-------------------
import AccountHeadIndex from "./components/pages/AccountHead/Index";

//-----------Bank-------------------
import BankIndex from "./components/pages/Bank/Index";

//-----------Category-------------------
import CategoryIndex from "./components/pages/Category/Index";

//-----------Item-------------------
import ItemIndex from "./components/pages/Item/Index";

//-----------DeliveryOut-------------------
import DeliveryIndex from "./components/pages/Delivery/DeliveryIndex";

//-----------DeliveryIn-------------------
import DeliveryInIndex from "./components/pages/Delivery/DeliveryInIndex";

//-----------RentInvoice-------------------
import RentInvoiceIndex from "./components/pages/RentInvoice/RentInvoiceIndex";

//------------Reports-----------------
import ItemForecastReport from "./components/pages/Report/ItemForecastReport";

import DeliverySummaryReport from "./components/pages/Report/DeliverySummaryReport";
import LedgerReport from "./components/pages/Report/LedgerReport";
import CashBook from "./components/pages/Report/CashBook";
import DeliveryStockReport from "./components/pages/Report/DeliveryStockReport";
import CustomerDueListReport from "./components/pages/Report/CustomerDueListReport";
import VendorDueListReport from "./components/pages/Report/VendorDueListReport";

import PurchasePartyandItemWiseReport from "./components/pages/Report/PurchasePartyandItemWiseReport";
import SalePartyandItemWiseReport from "./components/pages/Report/SalePartyandItemWiseReport";
import RentInvoicePartyandItemWiseReport from "./components/pages/Report/RentInvoicePartyandItemWiseReport";
//-----------Item-------------------
// ItemDashboard removed - file not found

//-----------Master (Client & Vendor)-------------------
// MasterDashboard removed - file not found

//-----------Bank-------------------
// BankDashboard removed - file not found

//-----------Staff-------------------
// StaffDashboard removed - file not found

//-----------AccountHead-------------------
// AccountHeadDashboard removed - file not found

//-----------PurchaseOrder-------------------
// PurchaseOrderIndex removed - file not found

//-----------Purchase-------------------
import PurchaseIndex from "./components/pages/Purchase/PurchaseIndex";

//-----------Sale-------------------
import SaleIndex from "./components/pages/Sale/SaleIndex";

//-----------Stock-------------------
// StockTransferInIndex removed - file not found
// StockTransferOutIndex removed - file not found

//-----------PaymentReceipts-------------------
import PaymentReceiptsIndex from "./components/pages/PaymentReceipts/PaymentReceiptsIndex";

//-----------JournalEntry-------------------
import JournalEntryIndex from "./components/pages/JournalEntry/JournalEntryIndex";

//-----------StockReport-------------------
import StockReportIndex from "./components/pages/StockReport/Index";


// ---------------- Theme ---------------- //
const theme = createTheme({
  palette: {
    primary: { main: "#1a1f3a" },
    secondary: { main: "#0f1419" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          textTransform: "none",
        },
      },
    },
  },
});

//const Sidebar = ({ open, roleName }) => {
// ---------------- Layout ---------------- //
const Layout = () => {
  const { companyName, roleName, username, isAuthenticated } = useAuth();
  const isMobile = useMediaQuery('(max-width:768px)');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* Session Timeout Component - only render when authenticated */}
        {isAuthenticated && <SessionTimeout />}

        {/* PWA Status Component - Removed */}

        {/* Header with integrated menu */}
        <AppBar position="fixed" sx={{ zIndex: (t) => t.zIndex.drawer + 1, backgroundColor: '#2c3e6e' }}>
          <Toolbar sx={{ minHeight: '48px !important', height: '48px', px: 1 }}>
            {/* Company Name */}
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", textTransform: "uppercase", mr: 2 }}
            >
              <Link to="/Home" style={{ textDecoration: "none", color: "inherit" }}>
                <span style={{ fontFamily: 'Verdana, sans-serif', fontSize: '14px' }}>{companyName}</span>
              </Link>
            </Typography>

            {/* Navigation Menu - Desktop only */}
            {!isMobile && username !== "Counter" && <HorizontalNavbar />}

            {/* Spacer */}
            <Box sx={{ flexGrow: 1 }} />

            {/* Logout icon only */}
            <Logout />
          </Toolbar>
        </AppBar>

        {/* Content */}
        <Box
          sx={{
            pt: '48px',
            pb: isMobile ? '70px' : 0, // Add padding for bottom nav on mobile
            minHeight: '100vh',
            backgroundColor: '#f0f4f8',
          }}
        >
          <Box sx={{ p: 0 }}>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/Home" exact component={Home} />

              {/* Role */}
              <Route path="/RoleIndex" component={RoleIndex} />
              <Route path="/RoleDetail/:id" component={RoleDetail} />

              {/* User */}
              <Route path="/UserIndex" component={UserIndex} />
              <Route path="/UserCreate" component={UserCreate} />
              <Route path="/UserEdit/:id" component={UserEdit} />
              <Route path="/UserDetail/:id" component={UserDetail} />
              <Route path="/PasswordChange" component={PasswordChange} />

              {/* Client */}
              <Route path="/clientIndex" component={ClientIndex} />

              {/* Vendor */}
              <Route path="/vendorIndex" component={VendorIndex} />

              {/* AccountHead */}
              <Route path="/accountHeadIndex" component={AccountHeadIndex} />

              {/* Bank */}
              <Route path="/bankIndex" component={BankIndex} />

              {/* Category */}
              <Route path="/categoryIndex" component={CategoryIndex} />

              {/* Item */}
              <Route path="/itemIndex" component={ItemIndex} />
             
              {/* DeliveryOut */}
              <Route path="/DeliveryIndex" component={DeliveryIndex} />

              {/* DeliveryIn */}
              <Route path="/DeliveryInIndex" component={DeliveryInIndex} />

              {/* RentInvoiceIndex */}
              <Route path="/RentInvoiceIndex" component={RentInvoiceIndex} />

              {/* Sale */}
              <Route path="/SaleIndex" component={SaleIndex} />

              {/* Payment Receipts */}
              <Route path="/PaymentReceiptsIndex" component={PaymentReceiptsIndex} />

              {/* Journal Entry */}
              <Route path="/JournalEntryIndex" component={JournalEntryIndex} />

              {/* Stock Report */}
              <Route path="/StockReportIndex" component={StockReportIndex} />

              {/* Company */}
              <Route path="/CompanyEdit" component={CompanyEdit} />

              {/* Reports */}
              <Route path="/ItemForecastReport" component={ItemForecastReport} />
              <Route path="/DeliverySummaryReport" component={DeliverySummaryReport} />
              <Route path="/LedgerReport" component={LedgerReport} />
              <Route path="/CashBook" component={CashBook} />
              <Route path="/DeliveryStockReport" component={DeliveryStockReport} />
              <Route path="/CustomerDueListReport" component={CustomerDueListReport} />
              <Route path="/VendorDueListReport" component={VendorDueListReport} />
              <Route path="/PurchasePartyandItemWiseReport" component={PurchasePartyandItemWiseReport} />
              <Route path="/SalePartyandItemWiseReport" component={SalePartyandItemWiseReport} />
              <Route path="/RentInvoicePartyandItemWiseReport" component={RentInvoicePartyandItemWiseReport} />
            </Switch>
          </Box>
        </Box>

        {/* Mobile Bottom Navigation */}
        {isMobile && username !== "Counter" && <MobileBottomNav />}
      </Router>
    </ThemeProvider>
  );
};

// ---------------- Root ---------------- //
const App = () => {
  // Service worker and PWA functionality removed

  return (
    <Router>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
};
export default App;
